import api from '../utils/api';

// Fetch all admins
export const getAllAdmins = async (headers) => {
  try {
    const response = await api.get('/api/admin', headers);
    return response.data;
  } catch (error) {
    console.error('Error fetching all admins:', error.response ? error.response.data : error.message);
    throw error;
  }
};

// Fetch a specific admin by ID
export const getAdminById = async (id, headers) => {
  try {
    const response = await api.get(`/api/admin/${id}`, headers);
    console.log("", response.data)
    return response.data;
  } catch (error) {
    console.error(`Error fetching admin with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// // Create a new admin
// export const createAdmin = async (adminData, headers) => {
//   console.log("hello from create admin function", adminData);
//   try {
//     const response = await api.post('/api/admin', adminData, { headers });
//     return response.data;
//   } catch (error) {
//     console.error('Error creating admin:', error.response ? error.response.data : error.message);
//     throw error;
//   }
// };

// Create a new admin
export const createAdmin = async (adminData, headers) => {
  console.log("hello from create admin function", adminData);

  try {
    const response = await api.post('/api/admin', adminData, {
      headers: {
        ...headers, 
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating admin:', error.response ? error.response.data : error.message);
    throw error;
  }
};


// Update an existing admin
export const updateAdmin = async (id, adminData, headers) => {
  try {
    const response = await api.put(`/api/admin/${id}`, adminData, { headers });
    return response.data;
  } catch (error) {
    console.error(`Error updating admin with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};

// Delete an admin
export const deleteAdmin = async (id, headers) => {
  try {
    const response = await api.delete(`/api/admin/${id}`, headers);
    return response.data;
  } catch (error) {
    console.error(`Error deleting admin with ID ${id}:`, error.response ? error.response.data : error.message);
    throw error;
  }
};
